import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d13d46c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d13d46c')) {
      api.createRecord('2d13d46c', component.options)
    } else {
      api.reload('2d13d46c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d13d46c&", function () {
      api.rerender('2d13d46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/occupation/index.vue"
export default component.exports